import React from 'react'
import { MenuItem, TextField } from '@mui/material'

import usePipelines from '../hooks/api/usePipelines'
import PipelineView from '../setupWizard/PipelineSetup/PipelineView'
import SettingsFooter from './shared/SettingsFooter'
import useAlert from '../hooks/useAlert'

const Pipelines = () => {
  const {
    pipelines,
    selectedPipelineId,

    updatePipeline,
    updateStage,
    moveStage,
    removeStage,
    removePipeline,
    addStage,
    selectPipeline,
    savePipelines,
    reset,

    isLoading,
    hasLoadError,
  } = usePipelines()

  const { createAlert, createGenericErrorAlert } = useAlert()

  const onSuccess = () =>
    createAlert({
      severity: 'success',
      message: 'Successfully saved Pipelines',
    })
  const onFailure = () => createGenericErrorAlert()

  const selectedPipeline = pipelines.find((p) => p.id === selectedPipelineId)

  return (
    <>
      {selectedPipeline && (
        <TextField
          margin='dense'
          fullWidth
          label={'Select a pipeline'}
          value={selectedPipelineId}
          onChange={selectPipeline}
          select
          sx={{ mb: 2 }}
        >
          {pipelines.map((p, i) => (
            <MenuItem key={i} value={p.id}>
              {p.name}
            </MenuItem>
          ))}
        </TextField>
      )}
      {selectedPipeline && (
        <PipelineView
          pipeline={selectedPipeline}
          moveStage={moveStage}
          removeStage={removeStage}
          updatePipeline={updatePipeline}
          addStage={addStage}
          updateStage={updateStage}
          removePipeline={removePipeline}
        ></PipelineView>
      )}

      <SettingsFooter
        cancelButton={{
          onClick: reset,
          label: 'Cancel',
        }}
        saveButton={{
          onClick: () => savePipelines().then(onSuccess).catch(onFailure),
          label: 'Save',
        }}
      />
    </>
  )
}

export default Pipelines
